module.exports = "https://cdn.hellotech.com/client-assets/computer-blank-screen_e5a5370da7e15a84df9055c66365067f.png";